import ReactGA from "react-ga"

// Initialise react GA
ReactGA.initialize(
  [
    {
      trackingId: "UA-153785931-12",
      gaOptions: { name: "Studio" },
    },
  ],
  { debug: false, alwaysSendToDefaultTracker: false }
)

// ReactGA.initialize("UA-153785931-11")

export const googleEvent = (category, action) => {
  ReactGA.event(
    {
      category,
      action,
    },
    ["Studio"]
  )
}
